// extracted by mini-css-extract-plugin
export default {"button":"locker-box-table_button__CF5Ih","accentButton":"locker-box-table_accentButton__JZjIS"};